import React from 'react';
import { Link } from 'react-router-dom';
import {useDispatch} from "react-redux";
import {setSearchFilterType} from "../../../Features/Misc/activeSlice";
import {useSelector} from "react-redux";



const SearchFilter = ({numberOfResults, numberOfResultss}) => {

    // console.log(JSON.stringify(numberOfResultss,null,2))

    // const watchCount = numberOfResultss.watches
    // const readCount = numberOfResultss.reads
    // const learnCount = numberOfResultss.learns

    const navItems = [

        { filterType: "watches", iconClass: "ri-video-line", label: "Video", count: numberOfResultss.watches, iconColorClass: "text-pink-icon" },
        { filterType: "reads", iconClass: "ri-book-read-line", label: "Read", count: numberOfResultss.reads, iconColorClass: "text-pink-icon" },
        { filterType: "learns", iconClass: "ri-lightbulb-line", label: "Webinars", count: numberOfResultss.learns, iconColorClass: "text-pink-icon" },

    ];



    const dispatch = useDispatch();
    const { searchFilterType } = useSelector(state => state.active);

    const handleFilterClick = (filterType) => {
        dispatch(setSearchFilterType(filterType));
    };

    return (
        <nav className="flex items-center justify-between lg:justify-start space-x-2 md:space-x-6">
            {navItems.map((item, index) => (
                <button
                    key={index}
                    onClick={() => handleFilterClick(item.filterType)}
                    className={`flex justify-center items-center py-3 p-2 md:px-4 lg:text-xl font-medium hover:opacity-60 transition-opacity duration-300
                    ${item.iconColorClass} 
                    ${item.filterType === searchFilterType ? "text-gold-accent" : "text-white"} 
                    ${item.filterType === searchFilterType ? "bg-gold-accent rounded-lg" : ""}`}
                >
                    <i className={`${item.iconClass} mr-3`}></i>
                    <p>
                        <span className="hidden sm:inline-block">{item.label}</span> ({item.count})
                    </p>
                </button>
            ))}
        </nav>
    );
};

export default SearchFilter;